import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initWebAnalytics, pageView } from './web';
import { initMetaPixel, metaPageView } from './meta';
import { captureAttribution, sanitizeUrl } from './attribution';

// Mount once inside the router — ONE GA4 page_view + ONE Meta PageView per route
// change, with tokens/OTPs stripped from what analytics sees. UTMs are captured
// on landing so they survive sign-up and payment redirects.
export default function WebAnalytics() {
  const location = useLocation();

  useEffect(() => { captureAttribution(); initWebAnalytics(); initMetaPixel(); }, []);

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    if (location.pathname !== '/') pageView({ path: sanitizeUrl(path) || location.pathname, title: document.title });
    metaPageView(path);
  }, [location.pathname, location.search]);

  return null;
}
